<template>
    <div class="customer-info">
        <ul class="list-unstyled">
            <li class="font-weight-bold customer-info-name">{{name}}</li>
            <li class="customer-info-email">{{email}}</li>
            <li class="customer-info-phone" v-if="phone">{{phone}}</li>
        </ul>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import schedulingMixin from '../../mixins/schedulingMixin';

  export default {
    mixins: [schedulingMixin],
    data() {
        return {
            name: '',
            email: '',
            phone: ''
        };
    },
    methods: {
        populateData() {
            let i;
            for (i in this.customerInfo) {
                let info = this.customerInfo[i];
                if (this.$store.getters.response[info.id]) {
                    if (info.type == 'text') {
                        let name = this.$store.getters.response[info.id].value;
                        if (this.name) {
                            this.name = this.name + ' ' + name;
                        } else {
                            this.name = name;
                        }
                    } else if (info.type == 'email') {
                        this.email = this.$store.getters.response[info.id].value;
                    } else if (info.type == 'phoneNumber') {
                        this.phone = this.$store.getters.response[info.id].value;
                    }
                }
            }
        }
    },
    computed: {
        ...mapGetters('form', [
          'fields',
        ])
    },
    created() {
        this.populateData();
    }
  };
</script>
